var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M32 24.795c-1.164.296-1.884.013-2.53-.957l-4.594-6.356-.664-.88-5.365 7.257c-.613.873-1.256 1.253-2.4.944l6.87-9.222-6.396-8.33c1.1-.214 1.86-.105 2.535.88l4.765 6.435 4.8-6.4c.615-.873 1.276-1.205 2.38-.883l-2.48 3.288-3.36 4.375c-.4.5-.345.842.023 1.325L32 24.795zM.008 15.427l.562-2.764C2.1 7.193 8.37 4.92 12.694 8.3c2.527 1.988 3.155 4.8 3.03 7.95H1.48c-.214 5.67 3.867 9.092 9.07 7.346 1.825-.613 2.9-2.042 3.438-3.83.273-.896.725-1.036 1.567-.78-.43 2.236-1.4 4.104-3.45 5.273-3.063 1.75-7.435 1.184-9.735-1.248C1 21.6.434 19.812.18 17.9c-.04-.316-.12-.617-.18-.92v-1.555z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1.67 15.425h12.326c.133-5.72-7.14-8.77-11.64-4.3-1.713 1.7-2.23 3.92-2.143 6.246.197 5.33 4.058 8.673 9.283 8.087 2.97-.332 5.06-1.707 6.406-4.416.328-.66.593-1.35.93-2.12-1.156.36-1.8.688-2.474.86-3.154.806-6.01.082-8.046-2.26-1.15-1.322-1.7-2.94-1.788-4.733.004-.656.123-1.587.225-2.097C4.08 8.116 7.507 6.13 11.004 7.278 12.982 7.9 14.254 9.42 14.92 11.83c.146.527.254 1.07.368 1.553-9.71 0-19.53 0-28.174.002-.36-4.935 3.992-8.2 8.02-7.365 1.674.347 2.568 1.488 2.957 3.092.026.09.185.215.21.18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpress);
export default __webpack_public_path__ + "static/media/express.655438d1b3848caa3ba255045291162e.svg";
export { ForwardRef as ReactComponent };